/**
 * @generated SignedSource<<4a9475fc5ccf487ceb63b2559e20a74b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_user">;
  readonly " $fragmentType": "PdpSharedSellerItemsCarousel_user";
};
export type PdpSharedSellerItemsCarousel_user$key = {
  readonly " $data"?: PdpSharedSellerItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7cea595d5899c61bfda88cab30de045a";

export default node;
